import { jsx as r } from "react/jsx-runtime";
import { Fragment as n } from "react";
import '../../assets/Row.css';function c({ cells: o, className: m = "" }) {
  return /* @__PURE__ */ r("tr", { className: "row " + m, children: o.map((t, e) => /* @__PURE__ */ r(n, { children: t }, e)) });
}
export {
  c as Row
};
//# sourceMappingURL=Row.js.map
